export const categoryMappings: { [key: string]: string } = {
    'Destination/nightlife': 'nightlife',
    'EventbriteCategory/103': 'music',
    'EventbriteCategory/105': 'performing_arts',
    'EventbriteCategory/116': 'holidays',
    'EventbriteCategory/107': 'health',
    'EventbriteCategory/119': 'hobbies',
    'EventbriteCategory/101': 'business',
    'EventbriteCategory/110': 'food_drink',
};
